import * as React from 'react';
import { Button } from 'react-bootstrap';
import IconButton from '../../../components/button/IconButton';
import { useTranslation } from 'react-i18next';

const columns = (t) => {
  return [
    {
      field: 'toolType',
      label: 'toolTable.type',
      sort: 'desc',
      width: 53,
      type: 'enum',
      enumType: 'enums/toolType',
    },
    {
      label: 'toolTable.toolNumber',
      field: 'toolNumber',
      sort: 'desc',
      width: 53,
    },
    {
      field: 'labelling',
      label: 'toolTable.labelling',
      sort: 'desc',
      width: 53,
    },
    {
      field: 'verified',
      label: 'toolTable.verified',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: function (column, row, history) {
        return (
          <>
            {row.verified ? (
              <i className="far fa-check-circle text-primary"></i>
            ) : (
              <i className="far fa-times-circle text-secondary"></i>
            )}
          </>
        );
      },
    },
    {
      field: 'expertiseVerified',
      label: 'toolSection.verified2',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: function (column, row, history) {
        return (
          <>
            {row.expertiseVerified ? (
              <i className="far fa-check-circle text-primary"></i>
            ) : (
              <i className="far fa-times-circle text-secondary"></i>
            )}
          </>
        );
      },
    },
    {
      field: 'expertiseComment',
      label: 'general.comment',
      sort: 'desc',
      width: 53,
      type: 'textarea',
    },
    {
      field: 'expertiseHeadOk',
      label: 'visualVerification.head',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: (column, row, history) => {
        if (!row.expertiseVerified) {
          return <></>;
        }
        return (
          <>
            {row.expertiseHeadOk ? (
              <i className="far fa-check-circle text-primary"></i>
            ) : (
              <i className="far fa-times-circle text-danger"></i>
            )}
          </>
        );
      },
    },
    {
      field: 'expertiseStemOk',
      label: 'visualVerification.stem',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: (column, row, history) => {
        if (!row.expertiseVerified) {
          return <></>;
        }

        return (
          <>
            {row.expertiseStemOk ? (
              <i className="far fa-check-circle text-primary"></i>
            ) : (
              <i className="far fa-times-circle text-danger"></i>
            )}
          </>
        );
      },
    },
    {
      field: 'expertiseTipOk',
      label: 'visualVerification.tip',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: (column, row, history) => {
        if (!row.expertiseVerified) {
          return <></>;
        }
        return (
          <>
            {row.expertiseTipOk ? (
              <i className="far fa-check-circle text-primary"></i>
            ) : (
              <i className="far fa-times-circle text-danger"></i>
            )}
          </>
        );
      },
    },

    {
      field: 'actions',
      label: 'toolTable.actions',
      sort: 'desc',
      width: 53,
      type: 'custom',
      custom: function (column, row, history, additionalInformation) {
        return (
          <>
            {row.verified ? (
              <IconButton
                variant="outline-primary"
                size={'sm'}
                className="btn-circle"
                role="button"
                icon={' fa-arrow-left '}
                tooltip={t('toolTable.details')}
                onClick={() => {
                  history.push('?tool=' + row.id);
                }}
              />
            ) : (
              ''
            )}
          </>
        );
      },
    },
  ];
};

export default columns;
